<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-row>
          
            <v-col cols="3" class="text-xs-right">
      <v-btn color="#7BC243" to="/catalogue" class="white--text cataloguebtn">View All Catalogues </v-btn>
    </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-card-title>
            <v-row>
              <v-col cols="4" md="4">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search By Outturn"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="8" class="text-right">
                <h4>{{ records[0]?.documentUpload?.fileName }}</h4>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
         
            <v-data-table
  :loading="loading"
  v-model="selected"
  :headers="computedHeaders"
  :items="records"
  item-key="id"
  show-select
  class="elevation-1"
  :search="search"
  :single-select="singleSelect"
  @click:select-all="onSelectAll" 
>

             

              <template
  v-slot:top
  v-if="records && hasCanBeApprovedData(records) && $can('CAN_APPROVE_CATALOGUE')"
>
  <v-btn class="mr-2" @click="confirmAction('APPROVE_SELECTED')" color="primary">
    Approve Selected
  </v-btn>

  <v-btn
    v-if="canRejectRecords()"
    class="ml-2"
    @click="confirmAction('REJECT_SELECTED')"
    color="warning"
  >
    Reject Selected
  </v-btn>

  <v-btn class="ml-2" @click="confirmAction('APPROVE_ALL')" color="success">
    Approve All
  </v-btn>

  <v-btn
    v-if="canRejectRecords()"
    class="ml-2"
    @click="confirmAction('REJECT_ALL')"
    color="warning"
  >
    Reject All
  </v-btn>
</template>

<template v-slot:[`item.data-table-select`]="{ isSelected, select, item }">
  <v-simple-checkbox
    :ripple="false"
    color="green"
    :value="isSelected"
    @input="select($event)"
    v-if="canShowCheckbox(item, currentUserRole) && $can('CAN_APPROVE_CATALOGUE')"
  ></v-simple-checkbox>
</template>



              



              <template v-slot:[`item.actions`]="{ item }">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      v-on="on"
                      text
                      icon
                      class="actions"
                    >
                      <v-icon class="secondary--text"> more_horiz</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                    v-if="
                        ($can('CAN_UPLOAD_CATALOGUE') &&
                          hasGrnApproveMillerData(item)) ||
                        ($can('CAN_APPROVE_CATALOGUE') &&
                          hasGrnApproveWarehouseData(item))
                      "
                      
                      @click="showEditDialog(item, 'edit')"
                    >
                      <v-list-item-title> Edit</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      v-if="
                        $can('CAN_UPLOAD_CATALOGUE') && hasGrnApproveMillerData(item)
                      "
                      @click="showEditDialog(item, 'approve')"
                    >
                      <v-list-item-title> Approve</v-list-item-title>
                    </v-list-item>
              
                      <v-list-item  @click="showWarrantDetailsDialog(item)">
                        <v-list-item-title> View Details </v-list-item-title>
                      </v-list-item>
                    
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="confirmDialog" max-width="400">
      <v-card>
        <v-card-title
          class="body-2 primary--text font-weight-bold text-capitalize"
          >Catalogue Records
        </v-card-title>
        <v-card-text class="primary--text">
          {{ confirmMessage }}
          <v-text-field
            name="comment"
            label="Comment"
            v-model="approverComment"
            :rules="commentRules"
            required
          >
          </v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="confirmDialog = false"
            class="font-weight-bold"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            class="accent--text logoutbtn"
            @click="approveRecords()"
            :disabled="confirming"
          >
            <v-progress-circular v-if="confirming" indeterminate size="20" color="white" class="mr-2"></v-progress-circular>
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline accent--text"
          >{{ action }} Catalogue Record</v-card-title
        >
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="grnRecord.outturn"
                  label="OutTurn"
                  v-bind:readonly="approve"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="grnRecord.numberOfBags"
                  label="Bags"
                  required
                  v-bind:readonly="approve"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="grnRecord.numberOfPocket"
                  label="Pockets"
                  required
                  v-bind:readonly="approve"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="grnRecord.splitNumber"
                  label="Split Number"
                  required
                  v-bind:readonly="approve"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="grnRecord.lotNumber"
                  label="Lot Number"
                  required
                  v-bind:readonly="approve"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="grnRecord.weight"
                  label="Gross W"
                  required
                  v-bind:readonly="approve"
                >
                </v-text-field>
              </v-col>
             
             
            </v-row>
         
          </v-form>
        </v-card-text>

        <v-card-actions v-if="approve">
          <v-btn
            color="white"
            class="accentd--text"
            style="font-weight: 700"
            @click="editDialog = false"
            >Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="triggerApproveRecord">Approve</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-btn
            color="white"
            class="accentd--text"
            style="font-weight: 700"
            @click="editDialog = false"
            >Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="triggerEditRecord">Edit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
     <v-dialog v-model="warrantDetailsDialog" max-width="900">
      <v-card>
        <v-card-title class="title accent--text text-capitalize">
          Details
        </v-card-title>
        <v-card-text>
          <v-row v-if="warrantDetailsLoading" justify="center" align="center" class="pa-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <div class="ml-4">Loading  details...</div>
          </v-row>
          <v-data-table
            v-else
            :headers="warrantDetailsHeaders"
            :items="warrantDetails"
            class="mytable"
            hide-actions
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="body-2 font-weight-regular accent--text"
                v-text="header.text"
              />
            </template>
        
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer> </v-spacer>
          <v-btn color="primary" round @click="closeWarrantDetails">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from 'axios'
import config from '../../../../config'

export default {
  name: "cataloguefiledetails",
  data: function () {
    return {
      headers: [
        { text: "LotNumber", value: "lotNumber" },
        // { text: "OutTurn", value: "outturn" },
        { text: "BrokerOutturn", value: "brokerOutturn" },
        { text: "Grade", value: "grade" },
        { text: "Marks", value: "marks" },
        { text: "Bags", value: "numberOfBags" },
        { text: "Pockets", value: "numberOfPocket" },
        { text: "TotalWeight", value: "weight" },
        { text: "SplitNumber", value: "splitNumber" },
        { text: "Season", value: "season" },
        { text: "SaleNo", value: "saleNumber" },
        // { text: "Miller", value: "millerCode" },
        { text: "Broker", value: "agentCode" },
        { text: "Warehouse", value: "warehouseCode" },
        { text: "Actions", value: "actions" },
      ],
      selected: [],
      recordsToApprove: [],
      search: "",
      singleSelect: false,
      grnRecord: {},
      editDialog: false,
      approve: false,
      valid: true,
      action: "",
      confirmDialog: false,
      confirmMessage: "",
      commentRules: [(v) => !!v || "Comment is required"],
      approverComment: "",
      record_count: 0,
      userID:0,
      showProgressBar:false,
      confirming: false,
        warrantDetailsDialog: false,
              warrantDetailsLoading: false,

      warrantDetails:[],
         warrantDetailsHeaders: [
        { text: "Outturn", value: "outTurn" },
        { text: "Bags", value: "numberOfBags" },
        { text: "Pockets", value: "numberOfPocket" },
         { text: "Weight", value: "weight" },
        { text: "Miller", value: "miller.organisationCode" },
        { text: "Warrant Number", value: "grnWarrantNumber" },
       
      ],
    };
  },
  watch: {},
  computed: {
    ...mapState({
      loading: (state) => state.cataloguefile.loading,
      records: (state) => state.cataloguefile.records,
      user: (state) => state.user ,
    }),
  
shouldShowCheckbox() {
    return this.$can('CAN_APPROVE_CATALOGUE');
  },
    computedHeaders() {
      // Check if the status column should be added
      const showStatus = this.hasGrnStatus().length > 0;
      const headers = [...this.headers];

      if (showStatus) {
        // Insert the status header at the desired position
        headers.splice(12, 0, { text: "Status", value: "status.statusName" });
      }

      return headers;
    },
    currentUserRole: function() {
      console.log("Current user",this.user.roleId.name)
    return this.user?.roleId?.name || "";
  },
    userId: function () {
      if (this.user) {
        console.log("user - ", this.user);
        console.log("user2 - ", this.user.organisation.organisationType);
        console.log("username - ", this.user.username);
        console.log("userRole - ", this.user.roleId.name);
        this.organisationType = this.user.organisation.organisationType.name;
        this.organisationId = this.user.organisation.id;
        this.userID = this.user.id;
        this.username = this.user.username;
        // this.currentUserRole=this.user.roleId.name
        return this.user.id;
      }
      return 0;
    }
 
  },
    methods: {
      closeWarrantDetails() {
        this.warrantDetailsDialog = false;
        this.warrantDetails = [];  // Clear the warrant details
      },
       showWarrantDetailsDialog(item) {      this.viewWarrantDetails(item)

      this.warrantDetailsDialog = true;
    },
       viewWarrantDetails (item) {
      const url = config.serverURI + '/upload/catalogue/getAdditionalCatalogueDetails'
      this.warrantDetailsLoading = true;
      axios({ url: url, method: 'POST', data: item })
        .then(response => {
          console.log('Received Payments', response.data)
          this.warrantDetails = response.data
        })
        .catch(error => {
          console.log('error', error.response)
          this.message = 'Failed to load warrant details'
          this.snackbar = true
          this.snackbarColor = 'error'
        })
        .finally(() => {
          this.warrantDetailsLoading = false
        })
      return this.warrantDetails
    },
    onSelectAll(isSelected) {
    // Dynamic role-to-status permission mapping
    const statusRoleMap = {
      3: ["MARKETER_CHECKER", "WAREHOUSE_CHECKER", "BROKER_CHECKER"], // PENDING_APPROVAL
      23: ["MARKETER_CHECKER", "BROKER_CHECKER"], // PENDING_BROKER_APPROVAL
      90: ["WAREHOUSE_CHECKER"] // PENDING_WAREHOUSE_APPROVAL
    };

    // Get all status IDs where the current role is allowed
    const allowedStatusIds = Object.keys(statusRoleMap)
      .map(Number)
      .filter(statusId => statusRoleMap[statusId].includes(this.currentUserRole));

    if (isSelected) {
      this.selected = this.records.filter((record) =>
        record.status &&
        allowedStatusIds.includes(record.status.id) &&
        this.canShowCheckbox(record, this.currentUserRole)
      );
    } else {
      this.selected = [];
    }
  },
    getCatalogueDetails () {
			const url = config.serverURI + '/upload/catalogue/' + this.$route.params.id + '/data'
			console.log(url)
			axios.get(url)
				.then(response => {
					this.items = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
			return this.items
		},
    handleChange() {
      // Update deleteFlag to true if the checkbox is checked
      this.grnRecord.deleteFlag = true;
    },

confirmAction(action) {
  this.action = action;
  this.confirmDialog = true;

  const getValidRecords = (source) =>
    source.filter(
      (record) =>
        record.status &&
        this.canShowCheckbox(record, this.currentUserRole)
    );

  this.recordsToApprove = action.includes("SELECTED")
    ? getValidRecords(this.selected)
    : getValidRecords(this.records);

  this.confirmMessage =
    action + " - " + this.recordsToApprove.length + " records";
},
    hasGrnStatusIdData(item) {
      // Assuming item.status is the property containing status data
      // return this.records.filter(item => item.status !== null );
      return (
        item.status &&
        (item.status.statusName === "HOLDING_STATUS" ||
          item.status.statusName === "PENDING_WAREHOUSE_APPROVAL" ||
          item.status.statusName === "PENDING_APPROVAL")
      );
      // return this.records.filter(item => item.status !== null);
    },

    hasGrnApproveWarehouseData(item) {
      // Assuming item.status is the property containing status data
      // return this.records.filter(item => item.status !== null );
      return (
        item.status && (item.status.statusName === "PENDING_WAREHOUSE_APPROVAL"|| item.status.statusName === "PENDING_APPROVAL")
      );
    },

    hasGrnApproveMillerData(item) {

      return item.status && item.status.statusName === "REFERRED_TO_BROKER";
      // return this.records.filter(item => item.status !== null);
    },
    canRejectRecords() {
      // Assuming item.status is the property containing status data
      
      return (this.user.roleId.name==='BROKER_CHECKER'||this.user.roleId.name==='MARKETER_CHECKER'||this.user.roleId.name==='WAREHOUSE_CHECKER' )
      
    },



  canShowCheckbox(record, currentUserRole) {
  if (!record.status || !record.status.statusName) return false;

  const status = record.status.statusName;

  const rolePermissions = {
    PENDING_APPROVAL: ["MARKETER_CHECKER", "WAREHOUSE_CHECKER","BROKER_CHECKER"],
    PENDING_WAREHOUSE_APPROVAL: ["WAREHOUSE_CHECKER"],
    PENDING_BROKER_APPROVAL: ["MARKETER_CHECKER","BROKER_CHECKER"]
  };
  const result = rolePermissions[status]?.includes(currentUserRole) ?? false;
  console.log("Checkbox check:", { status, currentUserRole, result });
  return result;
  
},
    hasCanBeApprovedData(records) {
      return (
        records.length > 0 &&
        records.some(
          (record) =>
            record.status && (record.status.statusName === "PENDING_APPROVAL"||record.status.statusName === "PENDING_WAREHOUSE_APPROVAL"||record.status.statusName === "PENDING_BROKER_APPROVAL")
        )
      );
    },
    hasCanBeApprovedByWarehouse(records) {
      return (
        records.length > 0 &&
        records.some(
          (record) =>
            record.status && record.status.statusName === "PENDING_WAREHOUSE_APPROVAL"
        )
      );
    },

    hasGrnStatus() {
      // Assuming item.status is the property containing status data
      // return this.records.filter(item => item.status !== null );
      return this.records.filter((item) => item.status !== null);
    },
    ...mapActions({
      warehouseApproveRecords2: "cataloguefile/warehouseApproveRecords2",
      warehouseApproveRecords: "cataloguefile/warehouseApproveRecords",
      editRecord: "cataloguefile/editRecord",
      millerApproveRecord: "cataloguefile/millerApproveRecord",
    }),
    showEditDialog(item, type) {
      console.log("Item>>>>",item)
      this.grnRecord = item;
      this.editDialog = true;
      this.action = type;
      if (type !== "edit") {
        this.approve = true;
      }
    },
    approveRecords() {
      this.confirming = true;
      if (this.recordsToApprove.length === 0) {
        this.$store.dispatch("alert/displayAlert", {
          snackbar: true,
          color: "error",
          message: "No record selected for action " + this.action,
        });
        this.confirming = false;
      } else {
        const recordData = {
          action: this.action,
          comment: this.approverComment,
          records: this.recordsToApprove,
        };
        this.warehouseApproveRecords2(recordData)
          .then((response) => {
            if (response.data.error === false) {
              this.$store.dispatch("alert/displayAlert", {
                snackbar: true,
                color: 'primary',
                message: response.data.message,
              });
            } else {
              this.$store.dispatch("alert/displayAlert", {
                snackbar: true,
                color: "error",
                message: response.data.message,
              });
            }
            this.$store.dispatch("cataloguefile/viewFile", this.$route.params.id);
            this.selected = [];
            this.confirmDialog = false;
            this.recordsToApprove = [];
            this.approverComment = "";
            this.confirmMessage = "";
            this.confirming = false;
          })
          .catch((error) => {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "error",
              message: error.response.data
                ? error.response.data.message
                : "Error ocurred",
            });
            this.confirming = false;
          });
      }
    },
    triggerEditRecord() {
      this.editRecord(this.grnRecord)
        .then((response) => {
          if (response.data.error === false) {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: 'primary',
              message: response.data.message,
            });
          } else {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "error",
              message: response.data.message,
            });
          }
          this.$store.dispatch("cataloguefile/viewFile", this.$route.params.id);
          this.selected = [];
          this.editDialog = false;
        })
        .catch((error) => {
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response.data
              ? error.response.data.message
              : "Error ocurred",
          });
          this.editDialog = false;
        });
    },
    triggerApproveRecord() {
      // this.millerApproveRecord(this.grnRecord).then(response => {
      this.editRecord(this.grnRecord)
        .then((response) => {
          if (response.data.error === false) {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: 'primary',
              message: response.data.message,
            });
          } else {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "error",
              message: response.data.message,
            });
          }
          this.$store.dispatch("cataloguefile/viewFile", this.$route.params.id);
          this.selected = [];
          this.editDialog = false;
        })
        .catch((error) => {
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response.data
              ? error.response.data.message
              : "Error ocurred",
          });
          this.editDialog = false;
        });
    },
  },

  created() {
    this.$store.dispatch("cataloguefile/resetcataloguefiles");
    this.$store.dispatch("cataloguefile/viewFile", this.$route.params.id);
   
  },

};
</script>
<style></style>
